import React, { createContext, useContext, useState, ReactNode } from 'react';

interface StorageContextType {
  storage: Record<string, any>;
  updateStorage: (obj: Record<string, any>) => void;
}

const StorageContext = createContext<StorageContextType | null>(null);

interface StorageProviderProps {
  children: ReactNode;
}

export const StorageProvider: React.FC<StorageProviderProps> = ({ children }) => {
  const [storage, setStorage] = useState<Record<string, any>>({});

  const updateStorage = (obj: Record<string, any>) => {
    const newStorage = { ...storage, ...obj };
    setStorage(newStorage);
  };

  return (
    <StorageContext.Provider value={{ storage, updateStorage }}>
      {children}
    </StorageContext.Provider>
  );
};

export const useStorage = (): StorageContextType => {
  const context = useContext(StorageContext);
  if (!context) {
    throw new Error('useStorage must be used within a StorageProvider');
  }
  return context;
};
